import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import Radium from "radium";

import { md } from "../utilities/styles";

const Link = Radium(RouterLink);

const flatMenuContainerStyles = {
  display: "none",
  textTransform: "uppercase",
  position: "fixed",
  width: "100%",
  zIndex: 3000,
  maxWidth: "1500px",
};

const linkStyles = {
  margin: "0 1em",
  fontWeight: 600,
  lineHeight: "3em",
  ":hover": {
    color: "magenta",
  },
};

const subscribeButtonStyles = {
  fontSize: "1em",
  textTransform: "uppercase",
  padding: ".5em",
  backgroundColor: "black",
  color: "white",
  border: "none",
  ":hover": {
    background: "linear-gradient(to right, #8116b4, magenta)",
    backgroundColor: "magenta",
  },
};

const eyeIconStyles = {
  width: "2em",
  margin: ".75em 0 0 1em",
  position: "fixed",
};

md(flatMenuContainerStyles, { display: "block" });

const headerStripStyles = {
  maxWidth: "1500px",
};

const FixedHeader = ({ history }) => {
  return (
    <div>
      <div
        className="header_strip--fixed flex justify-between"
        style={headerStripStyles}
        onClick={console.log}
      >
        <Link to="/">
          <img src="/eye-icon.svg" style={eyeIconStyles} />
        </Link>
      </div>
      <div style={flatMenuContainerStyles}>
        <div className="flex justify-between">
          <div>
            <div
              style={{ ...eyeIconStyles, height: "2em", cursor: "pointer" }}
              onClick={() => history.push("/")}
            ></div>
          </div>
          <div className="flex justify-end">
            <Link to="/about" style={linkStyles}>
              About
            </Link>
            <Link style={linkStyles} to="/trends">
              Trends
            </Link>
            <Link style={linkStyles} to="/news">
              Co-Op News
            </Link>
            <a
              href="http://eepurl.com/did_aT"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyles}
            >
              <button key={1} style={subscribeButtonStyles}>
                Subscribe
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Radium(FixedHeader));



// WEBPACK FOOTER //
// ./src/components/FixedHeader.js